import React from "react";
import {
  Box,
  Typography,
  Stack,
  Divider,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Images } from "./../../assets/common";
import "./index.scss";
import ApiService from "./../../services/api-service";
import { useDispatch, useSelector } from "react-redux";
import { setbalance } from "./../../action/balance";
import { useHistory } from "react-router-dom";
import { getBalance } from "../../asyncAction/asyncBalance";
import RefreshIcon from "@mui/icons-material/Refresh";
import { getTimeDue, kFormatter } from "../../constants/function";
import { useTranslation } from "react-i18next";
export default function Balance({ balance }) {
  const { t } = useTranslation("common");
  const history = useHistory();
  const dispatch = useDispatch();

  const { bal, hbar, matic, near, lastUpdated } = useSelector(
    (state) => state.balance
  );
  const [myBalance, setMyBalance] = React.useState(0);
  const [hbarBalance, setHbarBalance] = React.useState(0);
  const [maticBalance, setMaticBalance] = React.useState(0);
  const [nearBalance, setNearBalance] = React.useState(0);
  const [showRefreshIcon, setShowRefreshIcon] = React.useState(true);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    dispatch(getBalance());
  }, []);

  React.useEffect(() => {
    setMyBalance(bal);
    setHbarBalance(hbar);
    setMaticBalance(matic);
    setNearBalance(near);
    setLoading(false);
  }, [bal, hbar, matic, lastUpdated]);

  return (
    <Box
      sx={{ gap: "10px" }}
      className="__balance"
      onClick={() => history.push("/app/Wallet")}
      onMouseEnter={() => setShowRefreshIcon(true)}
      onMouseLeave={() => setShowRefreshIcon(false)}
    >
      { showRefreshIcon && (
          <IconButton id="refreshIcon"
                      sx={{
                        width: "0px",
                        display: "contents",
                        backgroundColor: "#1e1e1e",
                      }}
                      className={"_refresh_balance" + " _increase"}
                      title={
                        loading
                            ? t("refreshBalance")
                            : `${t("balance_updated")} ${getTimeDue(lastUpdated)}`
                      }
                      onClick={(e) => {
                        e.stopPropagation();
                        setLoading(true);
                        dispatch(getBalance());
                      }}
          >
            {loading ? (
                <CircularProgress
                    sx={{ width: "100% !important", height: "100% !important" }}
                    color="default"
                />
            ) : (
                <RefreshIcon className="refresh__" color="default" />
            )}
          </IconButton>
      ) }

      <Stack id="sikiIcon" direction="row" alignItems="flex-end" title={myBalance}>
        <img style={{ width: "23px", height: "23px" }} src={Images.tip_player} />
        <Typography>{kFormatter(myBalance.toFixed(2))}</Typography>
      </Stack>

      <Divider orientation="vertical" className="__balance_divider" />

      <Stack id="hbarIcon"
        className="__other_balance"
        direction="row"
        alignItems="flex-end"
        title={hbarBalance}
      >
        <img style={{ width: "23px", height: "23px" }} src={Images.hbar} />
        <Typography>{kFormatter(hbarBalance.toFixed(2))}</Typography>
      </Stack>

      <Divider orientation="vertical" className="__balance_divider" />

      <Stack id="maticIcon"
        className="__other_balance"
        direction="row"
        alignItems="flex-end"
        title={maticBalance}
      >
        <img style={{ width: "23px", height: "23px" }} src={Images.polygon_color} />
        <Typography>{kFormatter(maticBalance.toFixed(2))}</Typography>
      </Stack>

      <Divider orientation="vertical" className="__balance_divider" />

      <Stack id="nearIcon"
        className="_other_balance"
        direction="row"
        alignItems="flex-end"
        title={nearBalance}
      >
        <img style={{ width: "18px", height: "18px" }} src={Images.near_color} />
        <Typography>{kFormatter(nearBalance.toFixed(2))}</Typography>
      </Stack>

    </Box>


  );
}
